<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <div class="searchTitle">
            <b>HEALTH RESTART</b>
          </div>

          <el-table
              v-loading="loading"
              ref="multipleTable"
              :data="tableData"
              style="width: 100%; height:100%"
              border
              size="small"
              :row-style="{ height: 0 + 'px' }"
              :cell-style="{ padding: 0 + 'px' }"
              :header-cell-style="{
                background: '#2F384E',
                color: '#fff',
                height: '10px',
                padding: '0px',
              }"
          >
            <el-table-column property="seq" label="seq" width="70"></el-table-column>
            <el-table-column property="created_at" label="created_at" width="190"></el-table-column>
            <el-table-column property="container_name" label="container_name" width="150"></el-table-column>
            <el-table-column property="status" label="status" width="120"></el-table-column>
            <el-table-column property="health_url" label="health_url" min-width="260" show-overflow-tooltip></el-table-column>
            <el-table-column property="message" label="message" min-width="320" show-overflow-tooltip></el-table-column>
          </el-table>

          <div style="text-align:center; margin-top: 10px;">
            <el-pagination
                :current-page.sync="currentPage"
                :page-size="pageSize"
                :total="totalSize"
                layout="prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>

          <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
            <el-button
                :loading="loading"
                type="primary"
                @click="search"
            >Search</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  created() {
    document.onkeydown = this.NotReload;
    this.search();
  },
  data() {
    return {
      tableData: [],
      totalData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
    }
  },
  methods: {
    NotReload() {
      if ((event.ctrlKey == true && (event.keyCode == 78 || event.keyCode == 82)) || (event.keyCode == 116)) {
        event.keyCode = 0;
        event.cancelBubble = true;
        event.returnValue = false;
      }
    },
    async search() {
      this.loading = true;
      let url = this.$url + '/authInfo/getDockerRestartHistoryList';

      await Axios.post(url, {}, this.$store.state.config).then(res => {
        var resDataJson = res.data.dockerRestartHistoryDTO;
        this.totalData = [];
        if (res.data.resultCode) {
          for (var resData in resDataJson) {
            this.totalData.push({
              seq: Number(resData) + 1,
              id: resDataJson[resData]['id'],
              container_name: resDataJson[resData]['container_name'],
              health_url: resDataJson[resData]['health_url'],
              status: resDataJson[resData]['status'],
              message: resDataJson[resData]['message'],
              created_at: resDataJson[resData]['created_at'],
            });
          }
          this.totalSize = this.totalData.length;
          this.tableData = this.totalData.slice(0, this.pageSize);
          this.currentPage = 1;
          this.loading = false;
          this.$message.success(this.$store.state.searchSuccess);
        } else {
          this.$message.error(this.$store.state.dataNotFound);
          this.currentPage = 1;
          this.loading = false;
        }
      }).catch(() => {
        this.$message.error(this.$store.state.serverErrorMessage);
        this.currentPage = 1;
        this.loading = false;
      });
    },
    handleCurrentChange(val) {
      this.tableData = this.totalData.slice((this.pageSize * val - this.pageSize), this.pageSize * val);
    },
  }
}
</script>
